export default "__VITE_ASSET__35fe0c99__"